import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import '@fontsource/roboto';
import displayname from '../media/instruction/displayname.png'

const useStyles = theme => ({
  img:{
    maxWidth: '80%'
  },
  li:{
    paddingBottom: '10px'
  }
});


class InformedConsent extends React.Component {

    constructor(props){
        super(props);
        this.handleStart=this.handleStart.bind(this);
    }

    handleStart(event){
        event.preventDefault();
        window.location='/signup/';
        
    }

    render(){
      const { classes } = this.props;

      return (
          <div style={{padding: '40px', backgroundColor: 'white', paddingBottom: '100px'}}>
             <Typography variant='h5' className={classes.li}>
                Informed Consent for Experiment
              </Typography>
            <div style={{textAlign:'justify', marginBottom: '20px'}}>
              <Typography variant='body1' component={'ul'}>
                <li className={classes.li}>
                  This experiment is conducted for the sake of research only.
                </li>
                <li className={classes.li}>
                This research is to examine how people react to comments in comment sections. 
                </li >
                <li className={classes.li}>
                In this experiment, you are going to read a post and comments from an online comment section in response to a news article. Note that the post and comments can contain political, controversial contents.
                  </li>
                <li className={classes.li}>
                You are asked to comment on the post, or reply to user comments, or react (up/down vote) to user comments, as much as you want.                </li>
                <li className={classes.li}>
                <span style={{color: 'red'}}>Your comments, replies, and reactions will be recorded in the system and will be shown to other users of the system.</span> 
                  <ul>
                    <li>
                      NOTE: Your <span style={{color: 'red'}}>display name</span>, not your workername, will be shown to other users. Your worker ID will remain anonymous. 
                    </li>
                    <li>
                    We have assigned a random display name for you on your signup. You can check your display name on the top bar of this page, next to you worker ID.
                    </li>
                    <img className={classes.img} id='img-displayname' alt='gif on how to add hashtag buttons' src={displayname} />
                  </ul>
                </li>
                <li className={classes.li}>
                As your comments, replies, and reactions are shared by users of this system, any inappropriate data can be removed by researchers without any pre/post notifications.                </li>
                <li className={classes.li}>
                Your private and personal information (e.g., WorkerID) will be kept confidential and access to it by the general public will be restricted. If the results of this research are published, your identity will remain confidential.                </li>

                <li className={classes.li}>
                The final decision regarding whether or not to participate in this experiment is to be made by you. You can always decide not to participate in the tasks and can withdraw your participation anytime. Even if you refuse to participate in this research, you will not be disadvantaged at all.                </li>
                
                <li className={classes.li}>
                <span style={{color: 'red'}}> Note that your work can be rejected if you fail to pass attention check questions in pre/post survey questions or if you use the system insincerely. For example, writing a random question or making random, meaningless reactions (that might harm other participants) will be regarded as insincere participation in this study, and your work can be rejected. </span>
                </li>
                <li className={classes.li}>
                  Contact Information: If you have any questions or wish to express any discomfort related to this research, please feel free to contact the researcher below.
                  <ul>
                    <li>
                    Name of researcher: Eunyoung Ko, Contact: eunyoungko@kaist.ac.kr
                    </li>
                  </ul>
                </li>
              </Typography>
            </div> 

            <div>
              <Typography variant={'body1'}>
                I have read this Informed Consent and received a response to each and every question asked. I hereby confirm that I would like to voluntarily participate in the research.
              </Typography>
            </div>
              <div style={{float:'right', marginRight: '30px'}}>
              <form onSubmit={this.handleStart} >
              <Button variant='contained' color='primary'  className={classes.root} type="submit">
                Agree & Go To Pre-Survey
              </Button>
            </form>
            </div>
            </div>
        );
  }
}

export default withStyles(useStyles)(InformedConsent);
